import { useUser } from '@clerk/nextjs';
import { trpc } from '@web-app/utils/trpc';

export function useAccessNpReviewQueueStatus() {
  const { user, isLoaded } = useUser();
  return trpc.accessNpReview.hasQueue.useQuery(
    // Prevent a same-tab sign-in switch from reusing another NP's badge.
    { viewerId: user?.id ?? '' },
    {
      enabled: isLoaded && Boolean(user?.id),
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  );
}
